// src/pages/SuccessPage.jsx
import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { useAppContext } from '../../context/AppContext';
import { OnlineClubTrans, SuccessTrans, ToasterTrans } from '../../utils/translations';
import Class from "../../assets/photos/20.png";
import Lib from "../../assets/photos/22.png";
import Goose from "../../assets/photos/24.png";
import Online from "../../assets/photos/23.png";

export default function SuccessfulPayment() {
    //   const {
    //     isAuthenticated,
    //     user,
    //     loginWithRedirect,
    //     getAccessTokenSilently
    //   } = useAuth0();

    const { user, language, setToaster, getNextBillingDate } = useAppContext();

    const [subscriptionInfo, setSubscriptionInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    // 1. Once we know the user is authenticated, fetch their subscription details
    //   useEffect(() => {
    //     if (!isAuthenticated) return;

    //     (async () => {
    //       try {
    //         const token = await getAccessTokenSilently();
    //         const resp = await axios.get('/api/subscription/me', {
    //           headers: { Authorization: `Bearer ${token}` }
    //         });
    //         setSubscriptionInfo(resp.data);
    //       } catch (err) {
    //         console.error('Failed to load subscription info', err);
    //       } finally {
    //         setLoading(false);
    //       }
    //     })();
    //   }, [isAuthenticated, getAccessTokenSilently]);

    // 2. If not logged in, prompt to log in
    //   if (!isAuthenticated) {
    //     return (
    //       <div className="min-h-screen flex flex-col items-center justify-center px-4">
    //         <h1 className="text-2xl font-semibold mb-4">Subscription Activated!</h1>
    //         <p className="mb-6">
    //           We just need you to <strong>log in</strong> so we can tie your email to your subscription.
    //         </p>
    //         <button
    //           onClick={() => loginWithRedirect({ appState: { returnTo: '/success' } })}
    //           className="px-6 py-2 bg-pink-500 text-white rounded"
    //         >
    //           Log in
    //         </button>
    //       </div>
    //     );
    //   }

    // 3. Show loading state
    //   if (loading) {
    //     return (
    //       <div className="min-h-screen flex items-center justify-center">
    //         <p>Loading your subscription…</p>
    //       </div>
    //     );
    //   }

    // 4. Once logged in and data is loaded, render success details

   

    return (
        <div className="w-full mx-auto my-12 px-4">
            <h1 className="md:mt-o mt-16 text-2xl md:text-3xl font-bold mb-8 text-center">{SuccessTrans[language].payment}</h1>
            <div className="bg-white/70 p-4 rounded-md shadow-lg text-sm md:w-7/12 mx-auto">
                <p className="text-center mb-4">
                {SuccessTrans[language].yourSub}<strong>{SuccessTrans[language].active}</strong>{SuccessTrans[language].welcome}
                </p>
                <p>{SuccessTrans[language].firstStep}</p>
            </div>

            {/* WHAT’S INCLUDED */}
            <section className="mb-4 w-11/12 mx-auto">
                <section className="py-8 px-6 h-fit">
                    <h2 className="text-xl md:text-2xl font-semibold  text-center mb-4">{SuccessTrans[language].whatsAvailable}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto text-center">
                        {[
                            {
                                title: OnlineClubTrans[language].liveLessons,
                                description: SuccessTrans[language].liveLessonsDescription,
                                extra: SuccessTrans[language].liveLessonsExtra,
                                img: Class,
                                button: SuccessTrans[language].liveLessonsButton,
                                link: "/live"
                            },
                            {
                                title: OnlineClubTrans[language].library,
                                description: OnlineClubTrans[language].libraryDescription,
                                extra: OnlineClubTrans[language].libraryExtra,
                                img: Lib,
                                button: SuccessTrans[language].libraryButton,
                                link: "/library",
                            },
                            {
                                title: OnlineClubTrans[language].constructor,
                                description: OnlineClubTrans[language].constructorDescription,
                                extra: SuccessTrans[language].constructorExtra,
                                img: Online,
                                button: SuccessTrans[language].constructorButton,
                                link: "/constructor",
                            },

                            {
                                title: OnlineClubTrans[language].chat,
                                description: OnlineClubTrans[language].chatDescription,
                                extra: SuccessTrans[language].chatExtra,
                                img: Goose,
                                button: SuccessTrans[language].chatButton,
                                link: "https://t.me/+KpMztbN-sr8xNmMy"
                            },
                        ].map((item, idx) => (
                            <div
                                key={idx}
                                className="relative group w-full h-80 [perspective:1000px] mx-auto"
                            >
                                <div className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">

                                    {/* Front Side */}
                                    <div className="absolute inset-0 bg-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [backface-visibility:hidden]">
                                        <img src={item.img} alt={item.title} className="rounded-full w-24 h-24 object-cover mb-4" />
                                        <h3 className="text-xl md:text-2xl font-semibold mb-2">{item.title}</h3>
                                        <p className="text-sm mb-4">{item.description}</p>

                                        {/* Subtle mobile-only pointer in top-right */}
                                        <div className="absolute bottom-4 right-5 text-xs text-black opacity-80 md:hidden pointer-events-none select-none">
                                            ⤷
                                        </div>
                                    </div>

                                    {/* Back Side */}
                                    <div className="absolute inset-0 bg-brown text-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [transform:rotateY(180deg)] [backface-visibility:hidden]">
                                        <h3 className="text-xl font-semibold mb-4 text-white">{item.title}</h3>
                                        <p className="text-sm text-white">{item.extra}</p>
                                        {item.link && language === "russian" ? <a href={item.link} className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm">
                                            {item.button}
                                        </a> : <button className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm" onClick={() => {
                                            setToaster({
                                                message: ToasterTrans[language].comingSoon,
                                                type: "info",
                                                show: true,
                                            });
                                        }}>{item.button}</button>}
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </section>

            {/* YOUR CREDENTIALS */}
            <h2 className="text-xl font-semibold mb-2 text-center ">{SuccessTrans[language].account}</h2>
            <section className=" bg-white/70 p-4 rounded-md shadow-lg w-fit mx-auto px-10">
                <div className="space-y-1 text-sm">
                    <p>
                        <strong>Email:</strong> {user?.email}
                    </p>
                    <p>
                        <strong>{SuccessTrans[language].plan}:</strong> {user?.role.charAt(0).toUpperCase() + String(user?.role).slice(1)}
                    </p>
                    <p>
                        <strong>{SuccessTrans[language].started}:</strong>{' '}
                        {new Date(user?.subscriptions[user?.subscriptions?.length -1].startDate).toLocaleDateString('de-DE')}
                    </p>
                    <p>
                        <strong>{SuccessTrans[language].nextPayment}:</strong>{' '}
                        {getNextBillingDate(user?.subscriptions[user?.subscriptions?.length -1].startDate).toLocaleDateString('de-DE')}
                        {/* {new Date(subscriptionInfo.startDate).toLocaleDateString()} */}
                    </p>
                </div>
            </section>
        </div>
    );
}
